import React from "react";

const TableLoading = ({ cols = 4 }) => (
  <>
    {Array.from({ length: 12 }).map((_, index) => (
      <tr
        key={index}
        className="border-t bg-white"
      >
        {Array.from({ length: cols }).map((_, indexCol) => (
          <td
            className="font-medium text-gray-900 text-center py-2"
            key={indexCol}
          >
            <div role="status" className="max-w-sm animate-pulse inline">
              <div className="h-3 bg-gray-200 rounded-full w-20 mx-auto"></div>
            </div>
          </td>
        ))}
      </tr>
    ))}
  </>
);

export default TableLoading;
